module.exports = __webpack_public_path__ + "static/media/hand-cursor.0220c16b.svg";